'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configConsentLinkSelector = exports.layoutSelector = exports.configSelector = exports.activeDepositDataSelector = exports.hasVisibleErrors = exports.shouldShowConsentSelector = exports.activeCardNeedConsentSelector = exports.initialFormValuesSelector = exports.isLoadingSelector = exports.statusMessageSelector = exports.statusSelector = exports.activePaymentMethodTypeSelector = exports.activeCardSelector = exports.trackingDataSelector = exports.depositDataSelector = exports.securePaymentDataSelector = exports.isDefaultCardChangedSelector = exports.countryCodeSelector = exports.currencySymbolSelector = exports.currencyCodeSelector = exports.initDataSelector = exports.errorMessageSelector = exports.playerAmountSelectionSelector = exports.getIsApplePayAvailable = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _immutable = require('redux-form/immutable');

var _reselect = require('reselect');

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _constants = require('./constants');

var _customerPortalLink = require('./utils/customerPortalLink');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrives the initialisation data
 *
 * @param {StateType} state The application state
 * @returns {Object} The data used to initialise the component
 */
var getInitData = function getInitData(state) {
  return state.getIn(['quickDeposit', 'quickDepositInitData']).toJS();
};

var getIsApplePayAvailable = exports.getIsApplePayAvailable = function getIsApplePayAvailable(state) {
  return state.getIn(['quickDeposit', 'isApplePayAvailable']);
};

var getCurrencyCode = function getCurrencyCode(state) {
  return state.getIn(['quickDeposit', 'currency', 'ccy']);
};

var getCurrencySymbol = function getCurrencySymbol(state) {
  return state.getIn(['quickDeposit', 'currency', 'symbol']);
};

var getCountryCode = function getCountryCode(state) {
  return state.getIn(['quickDeposit', 'countryCode']);
};

var getIsDefaultCardChanged = function getIsDefaultCardChanged(state) {
  return state.getIn(['quickDeposit', 'isDefaultCardChanged']);
};

/**
 * Retrieves the deposit data
 *
 * @param {StateType} state The application state
 * @returns {Object} The component deposit data
 */
var getDepositData = function getDepositData(state) {
  return state.getIn(['quickDeposit', 'quickDepositData']).toJS();
};

/**
 * Retrieves the active deposit data
 *
 * @param {StateType} state The application state
 * @returns {Object} The component active deposit data
 */
var getActiveDepositData = function getActiveDepositData(state) {
  var activeDeposit = state.getIn(['quickDeposit', 'quickDepositData', 'activeDeposit']);
  return activeDeposit ? activeDeposit.toJS() : {};
};

/**
 * Retrieves the deposit status data
 *
 * @param {StateType} state The application state
 * @returns {Object} The component deposit status data
 */
var getStatus = function getStatus(state) {
  return state.getIn(['quickDeposit', 'quickDepositStatus']).toJS();
};

/**
 * Retrieves the 3DS deposit data
 *
 * @param {StateType} state The application state
 * @returns {Object} The component 3DS deposit data
 */
var get3DSData = function get3DSData(state) {
  return state.getIn(['quickDeposit', 'quickDeposit3DSData']).toJS();
};

/**
 * Retrieves the component configuration data
 *
 * @param {StateType} state The application state
 * @returns {Object} The component configuration data
 */
var getConfig = function getConfig(state) {
  return state.getIn(['quickDeposit', 'quickDepositConfig']).toJS();
};

/**
 * Retrieves the component tracking data
 *
 * @param {StateType} state The application state
 * @returns {Object} The component tracking data
 */
var getTrackingData = function getTrackingData(state) {
  return state.getIn(['quickDeposit', 'quickDepositTrackingData']).toJS();
};

/**
 * Retrieves if any of form fields was focused
 *
 * @param {StateType} state The application state
 * @returns {boolean} was form focused
 */
var getFormWasFocused = function getFormWasFocused(state) {
  return state.getIn(['quickDeposit', 'formWasFocused']);
};

/**
 * Retrieves layout
 *
 * @param {StateType} state The application state
 * @returns {string} layout
 */
var getLayout = function getLayout(state) {
  return state.getIn(['quickDeposit', 'quickDepositConfig', 'layout'], _constants.QD_DEFAULT_LAYOUT);
};

var getErrorMessage = function getErrorMessage(state) {
  return state.getIn(['quickDeposit', 'errorMessage']);
};

var getPlayerAmountSelection = function getPlayerAmountSelection(state) {
  return state.getIn(['quickDeposit', 'hasPlayerSetAmount']);
};

var playerAmountSelectionSelector = exports.playerAmountSelectionSelector = getPlayerAmountSelection;

var errorMessageSelector = exports.errorMessageSelector = getErrorMessage;

var initDataSelector = exports.initDataSelector = getInitData;

var currencyCodeSelector = exports.currencyCodeSelector = getCurrencyCode;

var currencySymbolSelector = exports.currencySymbolSelector = getCurrencySymbol;

var countryCodeSelector = exports.countryCodeSelector = getCountryCode;

var isDefaultCardChangedSelector = exports.isDefaultCardChangedSelector = getIsDefaultCardChanged;

var securePaymentDataSelector = exports.securePaymentDataSelector = get3DSData;

var depositDataSelector = exports.depositDataSelector = getDepositData;

var trackingDataSelector = exports.trackingDataSelector = getTrackingData;

var activeCardSelector = exports.activeCardSelector = function activeCardSelector(state) {
  return state.getIn(['quickDeposit', 'quickDepositData', 'activeCardMethod']);
};

var activePaymentMethodTypeSelector = exports.activePaymentMethodTypeSelector = (0, _reselect.createSelector)([activeCardSelector], function (activeCard) {
  return activeCard.get('payMthdType');
});

var statusSelector = exports.statusSelector = (0, _reselect.createSelector)([getStatus], function (data) {
  return data.status;
});

var statusMessageSelector = exports.statusMessageSelector = (0, _reselect.createSelector)([getStatus], function (data) {
  return data.messageData;
});

var isLoadingSelector = exports.isLoadingSelector = (0, _reselect.createSelector)([getStatus], function (data) {
  var loadingStates = [_constants.QD_STATUS_PMT_SUBMITTING];
  return loadingStates.indexOf(data.status) >= 0;
});

var initialFormValuesSelector = exports.initialFormValuesSelector = (0, _reselect.createSelector)([getInitData, getDepositData], function (initData, depositData) {
  return {
    cardId: depositData.lastActiveCardIndex,
    expiryDate: _quickDepositLogic.PaymentsApi.getExpiryDate(depositData.lastActiveCardIndex),
    amount: _quickDepositLogic.PaymentsApi.checkAmountBoundaries(depositData.lastActiveCardIndex, initData.amount),
    amountButtons: initData.amountButtons
  };
});

var activeCardNeedConsentSelector = exports.activeCardNeedConsentSelector = (0, _reselect.createSelector)(activeCardSelector, function (activeCard) {
  return activeCard.get('consent_given') === 'P';
});

var shouldShowConsentSelector = exports.shouldShowConsentSelector = (0, _reselect.createSelector)([activeCardNeedConsentSelector, getLayout, getFormWasFocused], function (needConsent, layout, formWasFocused) {
  return layout === 'horizontal' ? needConsent && formWasFocused : needConsent;
});

var hasVisibleErrors = exports.hasVisibleErrors = (0, _reselect.createSelector)([(0, _immutable.getFormMeta)(_constants.QD_RF_FORM_NAME), (0, _immutable.getFormSyncErrors)(_constants.QD_RF_FORM_NAME)], function (fieldsMap, errors) {
  var touchedFieldsKeys = fieldsMap.filter(function (field) {
    return field.get('touched');
  }).keySeq();
  var keysArray = touchedFieldsKeys.concat((0, _keys2.default)(errors));
  return keysArray.size !== keysArray.toSet().size;
});

var activeDepositDataSelector = exports.activeDepositDataSelector = getActiveDepositData;

var configSelector = exports.configSelector = getConfig;

var layoutSelector = exports.layoutSelector = getLayout;

var configConsentLinkSelector = exports.configConsentLinkSelector = (0, _reselect.createSelector)(getConfig, function (_ref) {
  var consentOnlyEvent = _ref.consentOnlyEvent,
      consentLink = _ref.consentLink,
      locale = _ref.locale;
  return consentOnlyEvent ? null : consentLink || (0, _customerPortalLink.getCustomerPortalConsentLink)(locale);
});